import { getHoursToCancel, getIsPenalizationFeatureOn } from '../config';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const SchedulePolicyModal = ({ show, event, onConfirm, onClose }) => {

  if (!show || !event) return null;

  const isPenalizationFeatureOn = getIsPenalizationFeatureOn();
  const hoursToCancel = getHoursToCancel();
  // ensure we have a dayjs instance (works if start_date is string, Date or dayjs)
  const start = dayjs.utc(event.start_date).local();
  const cancelLimit = start.subtract(hoursToCancel, 'hour');

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Política de cancelación</h5>
            <button type="button" className="close" onClick={onClose}>
              <span>&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <p>Recuerda que debes cancelar con <span className="font-weight-bold">{hoursToCancel} horas</span> de antelación para { isPenalizationFeatureOn ? 'no tener penalización y' : '' } que no se te descuente la clase.</p>
            <p> La fecha límite es: <span className="font-weight-bold">{cancelLimit.format('dddd D [de] MMMM [a las] HH:mm')}</span></p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancelar
            </button>
            <button type="button" className="btn themed-btn" onClick={() => onConfirm(event)}>
              Agendar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchedulePolicyModal;
